import { createIcon } from "@chakra-ui/react";

export const Support = createIcon({
  displayName: "Support",
  viewBox: "0 0 24 24",
  path: [
    <mask
      id="jb1lln5vra"
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="24"
      height="25"
    >
      <path fill="#D9D9D9" d="M0 .019h24v24H0z" />
    </mask>,
    <g clipPath="url(#6nreuaztxb)">
      <path
        fill="#FFBC58"
        d="M0 17.078c0 .18.15.328.333.328H2.75c.225 0 .446-.078.625-.217l1.78-1.403a4.71 4.71 0 0 1 2.916-1.005H14.5a.83.83 0 0 1 .833.82.83.83 0 0 1-.833.82h-3.333c-.646 0-1.167.514-1.167 1.15 0 .635.52 1.148 1.167 1.148h5.079a.99.99 0 0 0 .591-.193l4.9-3.552a1.01 1.01 0 0 1 1.4.21.974.974 0 0 1-.212 1.377l-5.275 3.823a5.041 5.041 0 0 1-2.962.96H.332a.332.332 0 0 0-.333.328v-4.594z"
      />
      <path
        fill="#fff"
        d="m12.237 3.62.975-.975a2.46 2.46 0 0 1 3.484 0 2.483 2.483 0 0 1 0 3.507l-4.234 4.237a.66.66 0 0 1-.462.192.643.643 0 0 1-.463-.192L7.304 6.156a2.483 2.483 0 0 1 0-3.507 2.46 2.46 0 0 1 3.483 0l.975.976c.13.131.346.131.475 0v-.004z"
      />
      <path
        fill="#2B2C3D"
        d="m12 2.924-.738-.739a3.138 3.138 0 0 0-4.433 0 3.129 3.129 0 0 0 0 4.43l4.234 4.233c.258.258.595.385.937.385.342 0 .68-.127.938-.385l4.233-4.233a3.129 3.129 0 0 0 0-4.43 3.138 3.138 0 0 0-4.433 0L12 2.924zm.238.697.975-.976a2.46 2.46 0 0 1 3.483 0 2.483 2.483 0 0 1 0 3.507l-4.234 4.237a.66.66 0 0 1-.462.192.643.643 0 0 1-.463-.192L7.304 6.156a2.483 2.483 0 0 1 0-3.507 2.46 2.46 0 0 1 3.483 0l.975.976c.13.131.346.131.476 0v-.004zm9.504 11.353a1.01 1.01 0 0 1 1.4.21.974.974 0 0 1-.213 1.377l-5.279 3.823a5.041 5.041 0 0 1-2.962.96H.332a.332.332 0 0 0-.333.328c0 .18.15.328.333.328h14.354a5.742 5.742 0 0 0 3.363-1.087l5.275-3.827c.742-.537.9-1.562.354-2.292a1.682 1.682 0 0 0-2.329-.35l-4.904 3.553a.34.34 0 0 1-.196.066h-5.083a.498.498 0 0 1-.5-.493c0-.27.225-.492.5-.492H14.5c.83 0 1.5-.66 1.5-1.476 0-.817-.67-1.477-1.5-1.477H8.07a5.4 5.4 0 0 0-3.333 1.148l-1.779 1.403a.348.348 0 0 1-.208.074H.333a.332.332 0 0 0-.333.328c0 .18.15.328.333.328H2.75c.225 0 .446-.078.625-.217l1.78-1.403a4.71 4.71 0 0 1 2.916-1.005H14.5a.83.83 0 0 1 .833.82.83.83 0 0 1-.833.82h-3.333c-.646 0-1.167.514-1.167 1.15 0 .635.52 1.148 1.167 1.148h5.079a.99.99 0 0 0 .591-.193l4.9-3.552h.005z"
      />
    </g>,
    <defs>
      <clipPath id="6nreuaztxb">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>,
  ],
  defaultProps: {
    "aria-label": "Hand holding a heart"
  }
});

export default Support;
